import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { NotificationDropdownComponent } from './topbar/notification-dropdown/notification-dropdown.component';
import { RouterModule } from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { InputIcon } from 'primeng/inputicon';
import { IconField } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule } from '@ngx-translate/core';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { NotificationsModule } from '../features/notifications/notifications.module';
import { TourOverlayModule } from '@shared/components/tour-overlay/tour-overlay.module';
import { StorePickerDialogModule } from '@shared/components/store-picker-dialog/store-picker-dialog.module';

@NgModule({
  declarations: [
    LayoutComponent,
    SidebarComponent,
    TopbarComponent,
    NotificationDropdownComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SidebarModule,
    InputIcon,
    IconField,
    InputTextModule,
    TranslateModule,
    BadgeModule,
    ButtonModule,
    PopoverModule,
    TooltipModule,
    ToastModule,
    NotificationsModule,
    TourOverlayModule,
    StorePickerDialogModule
  ],
  exports: [
    LayoutComponent
  ],
  providers: [
    MessageService
  ]
})
export class LayoutModule { }
